import { createAction } from '@reduxjs/toolkit';

export const setTenantAccessToken = createAction<string | null>(
  'tenantAuth/setAccessToken'
);
